import style from 'components/Header.module.scss'
import Logotype from 'components/Logotype'
import { Link } from 'gatsby'
import React from 'react'

const Header = () => {
  return (
    <header className={style.root}>
      <div className={style.content}>
        <div className={style.lockup}>
          <a
            href="https://www.coursera.org/"
            className={style.logotype}
            target="_blank"
            rel="noreferrer"
          >
            <Logotype />
          </a>
          <Link to="/" className={style.brand}>
            Teaching Center
          </Link>
        </div>
        <div className={style.externalLinks}>
          <a
            href="https://www.coursera.org/campus/"
            className={style.externalLink}
            target="_blank"
            rel="noreferrer"
          >
            Coursera for Campus
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
